import { PrivacyPolicy } from '@/features/consumer/privacy-policy';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_public/privacy-policy')({
  component: PrivacyPolicy,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      embed: (search.embed as string) || undefined,
    };
  },
});
